"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolygonDetailMarkerMap = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const maps_api_1 = require("maps-api");
const projection_1 = require("../../projection/projection");
const MapControlsLayout_1 = require("../MapControlsLayout/MapControlsLayout");
const EditPolygonButtons_1 = require("./EditPolygonButtons");
const LayerSwitchButton_1 = __importDefault(require("./components/LayerSwitchButton"));
const LocationMarker_1 = require("./LocationMarker");
const LauProvider_1 = require("../LauProvider");
function PolygonDetailMarkerMap({ geometry, onNewGeometry, editable, type, allowMultipolygon = false, icon, hideIcon = false }) {
    const mapObject = (0, react_1.useMemo)(() => (0, maps_api_1.createMap)({
        projection: projection_1.projection
    }), []);
    const [Container, map] = (0, maps_api_1.useMap)(mapObject);
    const [polygon, setPolygon] = (0, react_1.useState)();
    const [points, setPoints] = (0, react_1.useState)(geometry ?? [[]]);
    (0, react_1.useEffect)(() => {
        setPoints(geometry ?? [[]]);
    }, [geometry]);
    const focusOnPolygon = (0, react_1.useMemo)(() => {
        return geometry && geometry.flat().length > 0;
    }, []);
    const onEmptyGeometry = () => {
        setPoints([[]]);
    };
    const onAddGeometryShape = () => {
        setPoints([...points, []]);
    };
    const onClick = (e) => {
        if (!editable)
            return;
        const location = [e.latlng.lat, e.latlng.lng];
        setPoints((points) => {
            const newPoints = [...points];
            if (newPoints.length === 0)
                newPoints.push([]);
            newPoints[newPoints.length - 1].push(location);
            return newPoints;
        });
    };
    (0, react_1.useEffect)(() => {
        if (!map.initialized)
            return;
        if (focusOnPolygon && geometry)
            map.map.fitBounds(geometry.flat());
    }, [map, focusOnPolygon]);
    (0, react_1.useEffect)(() => {
        map.map.on("click", onClick);
        return () => {
            map.map.off("click", onClick);
        };
    }, [editable]);
    (0, react_1.useEffect)(() => {
        if (!map.initialized)
            return;
        onNewGeometry?.(points);
        if (points.flat().length === 0)
            return;
        const marker = map
            .createGeometryMarker(points, type, (marker, map) => {
            marker.getLeafletObject().on("click", onClick);
            if (hideIcon)
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            return icon || (0, jsx_runtime_1.jsx)(LocationMarker_1.LocationMarker, {});
        })
            .initialize();
        return () => {
            marker.delete();
        };
    }, [map, points, editable, icon, hideIcon]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "h-100", style: {
            position: "relative",
            zIndex: 0
        }, children: (0, jsx_runtime_1.jsx)(LauProvider_1.LauContainer, { map: map, setPolygon: setPolygon, autoFocus: !focusOnPolygon, children: (0, jsx_runtime_1.jsxs)(Container, { style: {
                    width: "100%",
                    height: "100%"
                }, children: [(0, jsx_runtime_1.jsx)(MapControlsLayout_1.MapControlsLayout, { map: map, lauPolygon: polygon, hideLegend: true, hideScale: true, hideSearchBar: true }), (0, jsx_runtime_1.jsx)("div", { children: editable && ((0, jsx_runtime_1.jsx)(EditPolygonButtons_1.EditPolygonButtons, { allowMultipolygon: allowMultipolygon, onEmptyClick: onEmptyGeometry, onAddShapeClick: onAddGeometryShape })) }), (0, jsx_runtime_1.jsx)("div", { style: {
                            position: "absolute",
                            top: 0,
                            right: 0,
                            margin: 10
                        }, children: (0, jsx_runtime_1.jsx)(LayerSwitchButton_1.default, { map: map }) })] }) }) }));
}
exports.PolygonDetailMarkerMap = PolygonDetailMarkerMap;
